<template>
  <detailTemplate :classCustom="'detail-docs extend-detail'">
    <template #content>
      <div class="back-icon border-radius__50 clickable flex-row flex__center" @click="backListPage()">
        <i class="el-icon-back font-size__large"></i>
      </div>

      <!--content-->
      <VuePerfectScrollbar class="scroll-area">
        <div class="body">
          <div class="font-size__large font-weight__bold margin-bottom-10" style="color: #007aff">
            CẬP NHẬT VĂN BẢN TRẢ VỀ ĐƠN VỊ
          </div>

          <!--THÔNG TIN YÊU CẦU & THÔNG TIN PHÒNG HỌP-->
          <div class="form-info padding-right-10 padding-bottom-10">
            <el-form inline-message>
              <div class="group__info margin-top-10 padding-bottom-10">
                <div class="content">
                  <div class="form-input">
                    <div class="title font-size__medium font-weight__bold margin-bottom-10 margin-top-10">THÔNG TIN VĂN
                      BẢN
                    </div>
                    <!--tieu de-->
                    <el-form-item class="custom-label__input width25">
                      <span class="label-input">Số văn bản:</span>
                      <el-input type="text" class="input-border__bottom input-border__radius__0 input-font__bold"
                                @blur="hcCaseDoc.docNum = hcCaseDoc.docNum.trim()"
                                size="mini" :readonly="true"
                                clearable maxlength="255" ref="title"
                                v-model="hcCaseDoc.docNum"
                      />
                    </el-form-item>

                    <el-form-item class="custom-label__input width25">
                      <span class="label-input">Số ký hiệu văn bản:</span>
                      <el-input type="text" class="input-border__bottom input-border__radius__0 input-font__bold"
                                @blur="hcCaseDoc.docSign = hcCaseDoc.docSign.trim()"
                                size="mini" :readonly="true"
                                clearable maxlength="255" ref="title"
                                v-model="hcCaseDoc.docSign"
                      />
                    </el-form-item>

                    <el-form-item class="custom-label__input width25">
                      <span class="label-input">Đơn vị ban hành:</span>
                      <el-input type="text" class="input-border__bottom input-border__radius__0 input-font__bold"
                                size="mini" :readonly="true"
                                clearable maxlength="255" ref="title"
                                v-model="hcCaseDoc.requestDeptName"
                      />
                    </el-form-item>

                    <el-form-item class="custom-label__input width25">
                      <span class="label-input">Ngày văn bản:</span>
                      <VueCtkDateTimePicker
                        color="#2d3e4f"
                        button-color="#2d3e4f"
                        :no-label="true"
                        label
                        disabled
                        :no-header="true"
                        v-model="hcCaseDoc.docDateFormatted"
                        class="picker-no_boder"
                        format="x"
                        output-format="x"
                        formatted="L"
                        :only-date="true"
                      />
                    </el-form-item>

                    <div class="title font-size__medium font-weight__bold margin-bottom-10 margin-top-10">THÔNG TIN
                      CHUYỂN VĂN BẢN
                    </div>
                    <el-form-item class="custom-label__input width25">
                      <span class="label-input">Chuyển cho Lãnh đạo</span>
                      <el-checkbox v-model="returnToLd"></el-checkbox>
                    </el-form-item>

                    <el-button size="medium" type="success" class="createNew" @click="clickAdd">
                      <div class="flex-row flex__center">
                        <i class="fas fa-plus-circle font-size__large"></i>
                        <span>&nbsp;&nbsp;THÊM MỚI</span>
                      </div>
                    </el-button>

                    <el-table
                      :data="hcCaseDocOrgs"
                      style="width: 100%"
                      v-show="!returnToLd"
                    >
                      <el-table-column
                        label="LÃNH ĐẠO">
                        <template slot-scope="scope">
                          <div>
                            <el-select
                              clearable
                              class="style-fullWidth input-font__bold input-border__bottom input-border__radius__0"
                              v-model="scope.row.approverId"
                              filterable
                              placeholder="-"
                            >
                              <el-option
                                v-for="item in hcCaseDocApprovers"
                                :key="item.approverId"
                                :label="item.approverFullname + ' - ' + item.positionName"
                                :value="item.approverId"
                              ></el-option>
                            </el-select>
                          </div>
                        </template>
                      </el-table-column>

                      <el-table-column
                        label="ĐƠN VỊ TRẢ">
                        <template slot-scope="scope">
                          <div>
                            <el-select
                              clearable
                              class="style-fullWidth input-font__bold input-border__bottom input-border__radius__0"
                              v-model="scope.row.returnDeptId"
                              filterable
                              placeholder="-"
                            >
                              <el-option
                                v-for="item in listDept"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id"
                              ></el-option>
                            </el-select>
                          </div>
                        </template>
                      </el-table-column>

                      <el-table-column
                        label="NỘI DUNG CHỈ ĐẠO">
                        <template slot-scope="scope">
                          <div>
                            <el-input class="input-border__bottom input-border__radius__0 input-font__bold"
                                      type="text" size="mini"
                                      maxlength="1000"
                                      v-model="scope.row.directionContent"
                            />
                          </div>
                        </template>
                      </el-table-column>

                      <el-table-column
                        label="DEADLINE">
                        <template slot-scope="scope">
                          <div>
                            <el-date-picker
                              v-model="scope.row.deadline"
                              type="date"
                              placeholder="Hạn hoàn thành"
                              format="dd/MM/yyyy"
                              value-format="timestamp"
                            >
                            </el-date-picker>
                          </div>
                        </template>
                      </el-table-column>

                      <el-table-column
                        fixed="right"
                        label="BÁO CÁO">
                        <template slot-scope="scope">
                          <el-checkbox :disabled="false" v-model="scope.row.isNeedReportBoolean"></el-checkbox>
                        </template>
                      </el-table-column>

                      <el-table-column
                        fixed="right"
                        label="THAO TÁC">
                        <template slot-scope="scope">
                          <span v-if="scope.row.isNew" class="icon_action fa fa-trash"
                                @click="handleDeleteReturnToDept(scope.$index, scope.row)"></span>
                        </template>
                      </el-table-column>
                    </el-table>

                    <el-table
                      :data="hcCaseDocTransferApprovers"
                      style="width: 100%"
                      v-show="returnToLd"
                    >
                      <el-table-column
                        label="LÃNH ĐẠO CHUYỂN">
                        <template slot-scope="scope">
                          <div>
                            <el-select
                              clearable
                              class="style-fullWidth input-font__bold input-border__bottom input-border__radius__0"
                              v-model="scope.row.approverIdFrom"
                              filterable
                              placeholder="-"
                            >
                              <el-option
                                v-for="item in hcCaseDocApprovers"
                                :key="item.approverId"
                                :label="item.approverFullname + ' - ' + item.positionName"
                                :value="item.approverId"
                              ></el-option>
                            </el-select>
                          </div>
                        </template>
                      </el-table-column>
                      <el-table-column
                        label="LÃNH ĐẠO NHẬN">
                        <template slot-scope="scope">
                          <div>
                            <el-select
                              clearable
                              class="style-fullWidth input-font__bold input-border__bottom input-border__radius__0"
                              v-model="scope.row.approverIdTo"
                              filterable
                              placeholder="-"
                            >
                              <el-option
                                v-for="item in leaders"
                                :key="item.id"
                                :label="item.fullName + ' - ' + item.positionName"
                                :value="item.id"
                              ></el-option>
                            </el-select>
                          </div>
                        </template>
                      </el-table-column>
                      <el-table-column
                        label="NỘI DUNG CHUYỂN">
                        <template slot-scope="scope">
                          <div>
                            <el-input
                              class="input-border__bottom input-border__radius__0 input-font__bold inputDirection"
                              type="text" size="mini"
                              maxlength="1000"
                              v-model="scope.row.directionContent"
                            />
                          </div>
                        </template>
                      </el-table-column>
                      <el-table-column
                        label="DEADLINE">
                        <template slot-scope="scope">
                          <div>
                            <el-date-picker
                              v-model="scope.row.deadline"
                              type="date"
                              placeholder="Pick a day"
                              format="dd/MM/yyyy"
                              value-format="timestamp"
                            >
                            </el-date-picker>
                          </div>
                        </template>
                      </el-table-column>
                      <el-table-column
                        fixed="right"
                        label="THAO TÁC">
                        <template slot-scope="scope">
                          <span v-if="scope.row.isNew" class="icon_action fa fa-trash"
                                @click="handleDeleteReturnToApprover(scope.$index, scope.row)"></span>
                        </template>
                      </el-table-column>
                    </el-table>

                  </div>
                </div>
              </div>
            </el-form>
          </div>
        </div>
      </VuePerfectScrollbar>
      <!--footer-->
      <div class="footer">
        <div class="flex-row flex__between">
          <div class="flex-row flex__left form-button__action">

            <el-button class="addDocs color__blue btn-none__border" size="mini" v-if="!returnToLd"
                       @click="traVeDonVi(1)">
              <i class="fas fa-arrow-circle-right font-size__small"></i>&nbsp;Hoàn thành trả về
            </el-button>

            <el-button class="addDocs color__blue btn-none__border" size="mini" v-if="!returnToLd"
                       @click="traVeDonVi(0)">
              <i class="fas fa-arrow-circle-right font-size__small"></i>&nbsp;Trả về đơn vị
            </el-button>

            <el-button class="addDocs color__blue btn-none__border" size="mini" v-if="returnToLd" @click="traVeLanhDao">
              <i class="fas fa-arrow-circle-right font-size__small"></i>&nbsp;Trả về lãnh đạo
            </el-button>
          </div>
        </div>
      </div>
    </template>
  </detailTemplate>
</template>

<script type="text/javascript">
    import VuePerfectScrollbar from "vue-perfect-scrollbar";
    import handleRequestErrorMixin from "../../handleRequestErrorMixin";
    import hanhchinhService from "../../../services/hanhchinhService";
    import {EventBus} from "../../../event-bus.js";
    import moment from "moment";
    import constants from "../../../constants";
    import h from "../../../services/h";

    export default {
        name: "luongVb_DetailReturn",
        mixins: [handleRequestErrorMixin],
        data() {
            return {
                returnToLd: false,
                leaders: [],
                listDept: [],
                hcCaseDoc: {},
                hcCaseDocOrgs: [],
                hcCaseDocTransferApprovers: [],
                hcCaseDocApprovers: []
            }
        },

        components: {
            VuePerfectScrollbar,
            detailTemplate: () => import("../../common/detail.vue"),
            Multiselect: () => import("vue-multiselect"),
            VueCtkDateTimePicker: () => import ("vue-ctk-date-time-picker")
        },

        created() {
            this.getData();
            this.getListLd();
            this.getListDept();
        },

        computed: {
            caseMasterId() {
                return this.$route.params.id;
            },

            currentDeptId() {
                let userDeptRole = h.find(
                    this.$store.state.userDeptRoles,
                    userDeptRole => userDeptRole.id === this.$store.getters.userDeptRoleId
                );
                return userDeptRole.deptId;
            },
            parentDeptId() {
                let userDeptRole = h.find(
                    this.$store.state.userDeptRoles,
                    userDeptRole => userDeptRole.id === this.$store.getters.userDeptRoleId
                );
                return userDeptRole.parentDeptId;
            }
        },

        methods: {
            backListPage() {
                this.$router.push({
                    name: "vbLuongVanBan",
                    query: this.$route.query,
                    params: this.$route.params
                });
            },

            getData() {
                hanhchinhService.getDetailReturn(this.caseMasterId).then(res => {
                    this.hcCaseDoc = {
                        caseMasterId: res.data.hcCaseDoc.caseMasterId,
                        docSign: res.data.hcCaseDoc.docSign,
                        docNum: res.data.hcCaseDoc.docNum,
                        docDateFormatted: res.data.hcCaseDoc.docDate !== null ? moment(res.data.hcCaseDoc.docDate).format("x") : null,
                        requestDeptName: res.data.hcCaseDoc.requestDeptName
                    };

                    this.hcCaseDocOrgs = [];
                    for (let i = 0; i < res.data.hcCaseDocOrgs.length; i++) {
                        this.hcCaseDocOrgs.push({
                            deadline: res.data.hcCaseDocOrgs[i].deadline,
                            isNeedReportBoolean: res.data.hcCaseDocOrgs[i].isNeedReport == 1,
                            approverId: res.data.hcCaseDocOrgs[i].approverId,
                            approverFullname: res.data.hcCaseDocOrgs[i].approverFullname,
                            returnDeptName: res.data.hcCaseDocOrgs[i].returnDeptName,
                            returnDeptId: res.data.hcCaseDocOrgs[i].returnDeptId,
                            directionContent: res.data.hcCaseDocOrgs[i].directionContent,
                            isNew: false
                        });
                    }

                    this.hcCaseDocTransferApprovers = [];
                    for (let i = 0; i < res.data.hcCaseDocTransferApprovers.length; i++) {
                        this.hcCaseDocTransferApprovers.push({
                            deadline: res.data.hcCaseDocTransferApprovers[i].deadline,
                            approverIdTo: res.data.hcCaseDocTransferApprovers[i].approverIdTo,
                            approverToFullname: res.data.hcCaseDocTransferApprovers[i].approverToFullname,
                            approverIdFrom: res.data.hcCaseDocTransferApprovers[i].approverIdFrom,
                            approverFromFullname: res.data.hcCaseDocTransferApprovers[i].approverFromFullname,
                            directionContent: res.data.hcCaseDocTransferApprovers[i].directionContent,
                            isNew: false
                        });
                    }

                    // Danh sách các lãnh đạo đã nhận trình văn bản (đã lọc trùng lắp nếu lãnh đạo được nhận nhiều lần)
                    this.hcCaseDocApprovers = [];
                    let flag = {};
                    for (let i = 0; i < res.data.hcCaseDocApprovers.length; i++) {
                        if (typeof flag[res.data.hcCaseDocApprovers[i].approverId] === 'undefined') {
                            flag[res.data.hcCaseDocApprovers[i].approverId] = true;
                            this.hcCaseDocApprovers.push({
                                id: res.data.hcCaseDocApprovers[i].id,
                                approverFullname: res.data.hcCaseDocApprovers[i].approverFullname,
                                approverId: res.data.hcCaseDocApprovers[i].approverId,
                                positionName: res.data.hcCaseDocApprovers[i].positionName,
                                positionId: res.data.hcCaseDocApprovers[i].positionId
                            });
                        }

                    }

                });
            },

            getListLd() {
                this.leaders = [];
                hanhchinhService.getListLD(this.$store.getters.globalRoles).then(res1 => {
                    res1.data.listLd.forEach(item => {
                        this.leaders.push(item);
                    });
                    hanhchinhService.getListLD(constants.HDTV_DEPT_CODE).then(res2 => {
                        res2.data.listLd.forEach(item => {
                            this.leaders.push(item);
                        });
                    });
                });
            },

            getListDept() {
                hanhchinhService.getDept(this.currentDeptId).then(res => {
                    res.data.departments.forEach(dept => {
                        this.listDept.push({
                            id: dept.id,
                            name: dept.deptName
                        });
                    });
                });
            },

            clickAdd() {
                if (this.returnToLd) {
                    this.hcCaseDocTransferApprovers.push({
                        deadline: new Date().getTime(),
                        approverIdTo: null,
                        approverToFullname: '',
                        approverIdFrom: null,
                        approverFromFullname: '',
                        directionContent: '',
                        isNew: true
                    });
                } else {
                    this.hcCaseDocOrgs.push({
                        deadline: new Date().getTime(),
                        isNeedReportBoolean: false,
                        approverId: null,
                        approverFullname: '',
                        returnDeptName: '',
                        returnDeptId: null,
                        directionContent: '',
                        isNew: true
                    });
                }
            },

            traVeDonVi(isFinish) {
                let returnItems = [];
                let fullData = true;
                this.hcCaseDocOrgs.forEach(item => {
                    if (item.isNew) {
                        returnItems.push({
                            approverId: item.approverId,
                            returnDeptId: item.returnDeptId,
                            directionContent: item.directionContent,
                            deadline: item.deadline,
                            isNeedReport: item.isNeedReportBoolean ? 1 : 0
                        });
                        if (!item.approverId || !item.returnDeptId) {
                            fullData = false;
                        }
                    }
                });
                if (!fullData) {
                    this.notifyError("Chưa nhập đủ thông tin Lãnh đạo hoặc đơn vị thực hiện");
                    return;
                }
                let form = {
                    caseMasterId: this.hcCaseDoc.caseMasterId,
                    isFinish: isFinish,
                    returnItems: returnItems
                };
                hanhchinhService.traVanBanDonVi(form).then(res => {
                    this.notifySuccess("Trả văn bản về đơn vị thành công");
                    EventBus.$emit("reloadPage", {});
                    this.backListPage();
                }).catch(error => this.getMessageError(error));
            },

            traVeLanhDao() {
                let returnItems = [];
                let fullData = true;
                this.hcCaseDocTransferApprovers.forEach(item => {
                    if (item.isNew) {
                        returnItems.push({
                            approverIdTo: item.approverIdTo,
                            approverIdFrom: item.approverIdFrom,
                            directionContent: item.directionContent,
                            deadline: item.deadline
                        });
                        if (!item.approverIdTo || !item.approverIdFrom) {
                            fullData = false;
                        }
                    }
                });
                if (!fullData) {
                    this.notifyError("Chưa nhập đủ thông tin Lãnh đạo chuyển và Lãnh đạo nhận");
                    return;
                }
                let form = {
                    caseMasterId: this.hcCaseDoc.caseMasterId,
                    returnItems: returnItems
                };
                hanhchinhService.traVanBanLanhDao(form).then(res => {
                    this.notifySuccess("Trả văn bản cho lãnh đạo thành công");
                    EventBus.$emit("reloadPage", {});
                    this.backListPage();
                }).catch(error => {
                    this.getMessageError(error);
                });
            },

            handleDeleteReturnToDept(index, row) {
                this.hcCaseDocOrgs.splice(index, 1);
            },

            handleDeleteReturnToApprover(index, row) {
                this.hcCaseDocTransferApprovers.splice(index, 1);
            },

            notifyError(msg) {
                this.notify('Lỗi', msg, 'error', 2000);
            },

            notifySuccess(msg) {
                this.notify('Thông báo', msg, 'success', 2000);
            },
        }
    };
</script>

<style scoped>
  .icon_action {
    font-size: 15px;
    padding: 10px;
  }

  .icon_action:hover {
    background: white;
    box-shadow: 0 8px 15px rgba(39, 124, 190, 0.25);
  }

  .createNew {
    background-color: var(--color-green);
    padding: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/views/adminstration/luongvanban/luongVb_DetailReturn.vue